<script setup lang="ts">
defineProps<{
  faqs: Record<string, { faqs: any[]; catIcon: string }>;
}>();
</script>

<template>
  <section id="faqCats" class="trek-faqs">
    <div v-for="(faqData, category) in faqs" :key="category" class="faq-item">
      <header>
        <div class="faq-icon" v-html="faqData.catIcon" />
        <h2>{{ category }}</h2>
      </header>

      <AppAccordion :acc-data="faqData.faqs" />
    </div>
  </section>
</template>
